var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-collapse',{attrs:{"accordion":_vm.accordion,"id":_vm.id,"visible":_vm.visible},on:{"hide":function($event){return _vm.$emit('hide')},"show":function($event){return _vm.$emit('show')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }